module.exports = __webpack_public_path__ + "static/hospital_support_profile1@2x-a8b3110bda5ba5b825c658816e9792ff.png";